import { ShoppingBagIcon } from 'lucide-react'
import { useMemo } from 'react'

import { useOptionalCart } from '~/hooks/data/use-cart'
import { Badge, Button } from '~/ui'

import { useOptionalCartContext } from './cart-context'
import { getTotalCartProducts } from './cart-utils'

export const CartDrawerTrigger = () => {
  const ctx = useOptionalCartContext()
  const cart = useOptionalCart()

  const numProducts = useMemo(
    () => (cart ? getTotalCartProducts(cart) : 0),
    [cart]
  )

  if (!ctx) return null

  return (
    <Button
      variant="ghost"
      size="md"
      onClick={() => ctx.setIsDrawerOpen((p) => !p)}
      aria-label="Open cart drawer"
      className="gap-1 px-2"
    >
      <ShoppingBagIcon className="size-4.5" />
      {numProducts > 0 && (
        <Badge className="bg-accent-primary text-accent-foreground text-2xs/none min-w-4 justify-center tabular-nums">
          {numProducts}
        </Badge>
      )}
    </Button>
  )
}
